/**
 * Take care importing code here! This is injected into every app as an individual script tag.
 */

// Number of milliseconds in a week (7 days * 24 hours * 60 minutes * 60 seconds * 1000 ms)
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
// for mocking in tests
export function getHostname() {
  return window.location.hostname;
}
export function isWebdriver() {
  return window.navigator.webdriver;
}

/**
 * Generates a unique theme ID for the current Trellis test day.
 * IDs are stable within a 24-hour test period and unique across different test days.
 * @param dateInput - Date components in UTC timezone
 * @returns Unique numeric ID for the test day
 */
export function getTrellisTestDayId(dateInput) {
  // We only want this to change once per Test Day and test days run for 24 hours
  // so the id we use is a function of the week number and the day index
  // Doing 0/1 for day index is fine since we only have 2 test days per week.
  const weeksSinceEpoch = Math.floor(dateInput.now / WEEK_MS);
  const dayIndex = dateInput.day === 2 || dateInput.day === 3 ? 0 : 1;
  return weeksSinceEpoch * 10 + dayIndex;
}

/**
 * Determines if the current time falls within a Trellis Test Day period.
 * Test days run for 24 hours: Tuesday 12:00 UTC - Wednesday 12:00 UTC
 * and Thursday 12:00 UTC - Friday 12:00 UTC.
 * @param dateInput - Date components in UTC timezone
 * @returns true if currently within a test day period
 */
export function isTrellisTestDay({
  day,
  hour
}) {
  // Trellis test days run:
  // 24 hours, starting at 12 UTC Tuesday
  // 24 hours, starting at 12 UTC Thursday
  return day === 2 && hour >= 12 || day === 3 && hour < 12 || day === 4 && hour >= 12 || day === 5 && hour < 12;
}

/**
 * Trellis test days work by deleting a users' chosen theme and overriding the default theme.
 * This way, any page load will use the new default theme unless they decide to change their setting,
 * at which point their new choice will take effect.
 *
 * This function clears the users' localStorage once per test day
 */
export function setupLocalStorageForTestDay(testDayId) {
  try {
    const prevTestDayId = localStorage.getItem('trellis:last-theme-id');
    if (!prevTestDayId || prevTestDayId !== testDayId) {
      // Legacy/debug theme override
      localStorage.removeItem('trellis:theme');
      localStorage.removeItem('hubspot-theme');
      localStorage.setItem('trellis:last-theme-id', testDayId);
    }
  } catch (e) {
    // do nothing
  }
}